import React from "react";
import { Button, message, Popconfirm } from "antd";

const DeletePop = ({ children, onConfirm, title }) => {
  const confirm = (e) => {
    onConfirm();
  };
  const cancel = (e) => {};
  return (
    <Popconfirm
      title={title || "Delete the task"}
      description="Are you sure to delete this?"
      onConfirm={confirm}
      onCancel={cancel}
      okText="Yes"
      cancelText="No"
      zIndex={2000}
      getPopupContainer={(trigger) =>
        trigger.closest(".ant-modal") || document.body
      }
    >
      {children}
    </Popconfirm>
  );
};
export default DeletePop;
